export class ServiceModel {
    public ServiceID: number = 0;
    public ObjektID: number = 0;
    public ServicerythmusID: number = 0;
    public LaufzeitVon: Date | null = null;
    public LaufzeitBis: Date | null = null;
    public Intervall: number | null = null;
}

export interface ServiceModelView extends ServiceModel {
    Bezeichnung: string
    Strasse: string
    PLZ: string
    Ort: string
    LandID: number
    LandName: string
    Intervall : number|null
    Servicerythmus : string|null
    RoofAreaCount: number
    SafetyPointCount: number
}
